import React, { lazy, Suspense } from 'react';
import { useWindowSize } from '../../hooks/useWindowSize';
import { MiniLoader } from '../minLoader';
import { IPopUP } from './type';

const WebPopUp = lazy(() => import('./webPopUp'));
const TooltipModal = lazy(() => import('../mobileTooltipModal/tooltipModal'));

export const ResponsePopUp: React.FC<IPopUP> = ({ header, content, trigger, id }) => {
  const { width = 0 } = useWindowSize();
  if (width > 600) {
    return (
      <Suspense fallback={<MiniLoader height="20px" />}>
        <WebPopUp id={id} trigger={trigger} content={content} />
      </Suspense>
    );
  }
  return (
    <Suspense fallback={<MiniLoader height="20px" />}>
      <TooltipModal id={id} triggerContent={trigger} title={header} content={content} />
    </Suspense>
  );
};
